import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  apiUrl: string = `${environment.backendUrl}/menus`;

    constructor(private http: HttpClient) { }

    httpOptions = {
        headers: {
            'Content-Type': 'application/json',
        }
    }

    httpOptionsMultiPart = {
      headers: {
          //'Content-Type': 'application/json',
      }
    }

    habilitaRegras(): Observable<boolean> {
      let searchParams = new HttpParams();
      return this.http.get<boolean>(`${this.apiUrl}/regras`,
       { params: searchParams, headers: this.httpOptions.headers });
    }



}
